export const getPaidPerdiemRequests = (state) => state.paidPerdiemRequests.results;
export const getPaidRequestsCount = (state) => state.paidPerdiemRequests.count;
export const getPaidPerdiemRequestsCsv = (state) => state.paidPerdiemRequestsCsv.results;